import { useMemo, useState } from "react";
import { ClassActionItem } from "@/types/feed";
import { useHomeScreenData } from "./useHomeScreenData";
import { transformFeedData } from "@/utils/feedDataTransformers";

export function useFeedData() {
  const [expiredClassActions, setExpiredClassActions] = useState<
    ClassActionItem[]
  >([]);
  const [claimedClassActions, setClaimedClassActions] = useState<
    ClassActionItem[]
  >([]);

  const {
    listFeed,
    suitList,
    unclaimedList,
    hotelReservationsList,
    purchasedProductsList,
    flightReservationsList,
    adgemOffersList,
    isLoading,
    refreshAllData,
    refetchFeed,
  } = useHomeScreenData();

  const listFeedToRender = useMemo(() => {
    return transformFeedData({
      listFeed,
      suitList,
      unclaimedList,
      hotelReservationsList,
      purchasedProductsList,
      flightReservationsList,
      adgemOffersList,
      setExpiredClassActions,
      setClaimedClassActions,
    });
  }, [
    listFeed.length,
    unclaimedList.length,
    hotelReservationsList.length,
    purchasedProductsList.length,
    flightReservationsList,
    adgemOffersList.length,
    suitList.length,
  ]);

  const hasData = listFeed && listFeed.length > 0;

  return {
    listFeedToRender,
    expiredClassActions,
    claimedClassActions,
    hasData,
    isLoading,
    refreshAllData,
    refetchFeed,
    // Also expose the suitResponse for the actions hook
    suitList,
  };
}
